export function getResolution() {
    return `${window.innerWidth}x${window.innerHeight}`;
}